import { ref, type Ref } from "vue"

const POLL_INTERVAL_MS = 10 * 60 * 1000

export function useAppVersionCheck(): { newVersionAvailable: Ref<boolean>; cleanup: () => void } {
  const newVersionAvailable = ref(false)

  const intervalId = setInterval(() => checkForNewVersion(newVersionAvailable), POLL_INTERVAL_MS)

  const onVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      checkForNewVersion(newVersionAvailable)
    }
  }
  document.addEventListener("visibilitychange", onVisibilityChange)

  const cleanup = () => {
    clearInterval(intervalId)
    document.removeEventListener("visibilitychange", onVisibilityChange)
  }

  return { newVersionAvailable, cleanup }
}

function parseVersionFromHtml(html: string): string | null {
  const match = html.match(/<meta\s+name="app-build-timestamp"\s+content="([^"]+)"/)
  return match ? match[1] : null
}

async function checkForNewVersion(newVersionAvailable: Ref<boolean>): Promise<void> {
  try {
    const response = await fetch(window.location.origin + "/index.html", { cache: "no-store" })
    const html = await response.text()
    const remoteVersion = parseVersionFromHtml(html)
    if (remoteVersion && remoteVersion !== import.meta.env.VITE_APP_BUILD_TIMESTAMP) {
      newVersionAvailable.value = true
    }
  } catch (error) {
    console.error("[app-version-check] failed to check for new version", error)
  }
}
